module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_1@3x.f5c350f0.png";